import { loadStripe, Stripe } from '@stripe/stripe-js';

let stripePromise;
export const getStripe = () => {
  if (!stripePromise) {
    // stripePromise = loadStripe(process.env.NEXT_PUBLIC_STRIPE_PUBLISHABLE_KEY || '');
    stripePromise = loadStripe(
      'pk_live_51Qv7JWCt8hj6uNRHDPzWiDMsLfynLdfuNXDJ0rrkTJ4UI0cOakbIo5VNCl1kkVrZ4eazHUOd2XBN9bBw3A3W0XIZ00RYV6y2GZ'
    );
  }
  return stripePromise;
};

export default getStripe;
